<template>
    <div>
        <Header />
        <div class="container mt-5">
            <div class="row justify-content-center">
                <div class="col-md-8 mt-5">
                    <div class="card border-light">
                        <div class="card-body text-center bg-transparent">
                            <div class="row">
                                <div class="col-12 offset-4 pl-0">
                                    <div class="logo" alt="">
                                    </div>
                                </div>
                            </div>
                            <div class="title mt-3">
                                EXPLORADOR DE GRABACIONES
                            </div>
                            <div class="mt-3 title-details">
                                Para ingresar, escriba su correo y contraseña
                            </div>
                        </div>
                        <div class="card-body bg-transparent">
                            <form v-on:submit.prevent="login">
                                <div class="form-group row">
                                    <div class="col-md-10 offset-md-1 pl-4">
                                        <div class="form-label-group">
                                            <input v-model="user.email" type="text" id="email"
                                                class="form-control form-control-custom" placeholder="ejemplo@mail.com"
                                                autofocus="autofocus" />
                                        </div>
                                        <small v-if="errors && errors.email"
                                            class="text-danger font-weight-bold">{{ errors.email[0] }}</small>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-10 offset-md-1 pl-4 pt-2">
                                        <div class="form-label-group">
                                            <input v-model="user.password" type="password" id="password"
                                                class="form-control form-control-custom" placeholder="Contraseña" />
                                            <small v-if="errors && errors.password"
                                                class="text-danger font-weight-bold">{{ errors.password[0]}}</small>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="form-group">
                                    <div class="col-md-10 offset-md-1 pl-4">
                                        <router-link class="d-block small mt-3 form-link" to="/reset-password-request">
                                            ¿Olvidó su contraseña?
                                        </router-link>
                                    </div>
                                </div> -->
                                <div class="form-group row mb-0 offset-md-4 pt-3">
                                    <div class="col-md-8 offset-md-0">
                                        <button type="submit" class="btn button-font btn-custom">
                                            Ingresar
                                        </button>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <FlashMessage position="right top"></FlashMessage>
        </div>
    </div>
</template>

<script>
    import Header from '@/components/HeaderAuthenticationComponent'
    import {
        AUTH_REQUEST
    } from '@/store/actions/auth'
    export default {
        name: 'LoginView',
        components: {
            Header
        },
        data() {
            return {
                logo_src: 'img/logo.png',
                logo_movigoo_src: 'img/logo_movigoo.png',
                user: {
                    email: '',
                    password: ''
                },
                errors: {}
            }
        },
        methods: {
            login: async function () {

                // try {
                // 	await auth.login(this.user);
                // 	this.errors = {};
                // 	this.$router.push('/2');
                // } catch (error) {
                // 	switch (error.response.status) {
                // 		case 422:
                // 			this.errors = error.response.data.errors;
                // 			break;
                // 		case 401:
                // 			this.errors = error.response.data.errors;
                // 			this.flashMessage.error({
                // 				title: 'Error',
                // 				message: error.response.data.message,
                // 				time: 3000
                // 			});
                // 			break;
                // 		case 500:
                // 			this.errors = error.response.data.errors;
                // 			this.flashMessage.error({
                // 				title: 'Error',
                // 				message: error.response.data.message,
                // 				time: 3000
                // 			});
                // 			break;
                // 		default:
                // 			this.flashMessage.error({
                // 				title: 'Error',
                // 				message: 'No se ha realizar la acción.',
                // 				time: 3000
                // 			});
                // 			break;
                // 	}
                // }
                this.signIn(this.user.email, this.user.password)
            },
            signIn(email, password) {
                this.$store.dispatch(AUTH_REQUEST, {
                    email,
                    password
                }).then(() => {
                    this.$router.push('/')
                }).catch((err) => {
                    console.log(err)
                    this.flashMessage.error({
                        title: 'Error',
                        message: 'Bad Credentials',
                        time: 3000
                    });
                })
                // this.$router.push('/')
            },
        }
    }
</script>

<style>

</style>